/**
 * @flow
 * @relayHash 36b8f5ac910cc2a77e5d646c4cebb32e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContentIssueTable_project$ref = any;
export type onpage_OnPageCategory_ContentIssueTable_QueryVariables = {|
  host: string
|};
export type onpage_OnPageCategory_ContentIssueTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: ContentIssueTable_project$ref
  |}
|};
export type onpage_OnPageCategory_ContentIssueTable_Query = {|
  variables: onpage_OnPageCategory_ContentIssueTable_QueryVariables,
  response: onpage_OnPageCategory_ContentIssueTable_QueryResponse,
|};
*/


/*
query onpage_OnPageCategory_ContentIssueTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...ContentIssueTable_project
    id
  }
}

fragment ContentIssueTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesContentIssues(url: {operator: AND, values: []}) {
          type
          severity
          count
        }
        contentIssues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, lenOrder: 0) {
          count
          edges {
            node {
              ...ContentIssueRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ContentIssueRow_issue on ContentIssue {
  id
  type
  severity
  content_len_wrd
  urls
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "kind": "Literal",
  "name": "url",
  "value": {
    "operator": "AND",
    "values": ([]/*: any*/)
  },
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "onpage_OnPageCategory_ContentIssueTable_Query",
  "id": null,
  "text": "query onpage_OnPageCategory_ContentIssueTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...ContentIssueTable_project\n    id\n  }\n}\n\nfragment ContentIssueTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesContentIssues(url: {operator: AND, values: []}) {\n          type\n          severity\n          count\n        }\n        contentIssues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, lenOrder: 0) {\n          count\n          edges {\n            node {\n              ...ContentIssueRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ContentIssueRow_issue on ContentIssue {\n  id\n  type\n  severity\n  content_len_wrd\n  urls\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "onpage_OnPageCategory_ContentIssueTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentIssueTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "onpage_OnPageCategory_ContentIssueTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesContentIssues",
                        "storageKey": "countTypesContentIssues(url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contentIssues",
                        "storageKey": "contentIssues(lenOrder:0,limit:20,offset:0,typeFilters:[],url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "lenOrder",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          },
                          v3
                        ],
                        "concreteType": "ContentIssuesConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContentIssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ContentIssue",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v4,
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "content_len_wrd",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urls",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7525915a84f43a563ae6480daebdf852';
module.exports = node;
